import compose from 'lodash/fp/compose';
import { firestoreAction } from 'vuexfire';

import {
  canAdd,
  canPublish,
  canUpdate,
  hasReferences,
  paginate,
  selectable,
  searchable
} from '../plugins';
import conceptsApi from '../../firebase/concepts';
import { db, FieldPath } from '../../firebase';
import PluggableModule from '../pluggable';
import { startsWithQuery } from '../../firebase/utils';

const concepts = new PluggableModule('concept');

concepts.addMutationTypes([
  'CONCEPT_VERSIONS_LOAD_INIT',
  'CONCEPT_VERSIONS_LOAD_DONE',
  'CONCEPT_VERSIONS_LOAD_ERROR'
]);

concepts.extend({
  namespaced: true,
  state: {
    loading: false,
    loadError: null,
    versions: []
  },
  mutations: {
    [concepts.con.CONCEPT_VERSIONS_LOAD_INIT]: function(state) {
      state.loading = true;
      state.loadError = null;
    },
    [concepts.con.CONCEPT_VERSIONS_LOAD_DONE]: function(state) {
      state.loading = false;
    },
    [concepts.con.CONCEPT_VERSIONS_LOAD_ERROR]: function(state, error) {
      state.loading = false;
      state.loadError = error;
    }
  },
  actions: {
    async addConcept({ commit }, data) {
      commit(concepts.con.CONCEPT_SUBMIT_INIT);
      try {
        const newConceptRef = await conceptsApi.add(data);
        commit(concepts.con.CONCEPT_CREATED, newConceptRef.id);
        commit(concepts.con.CONCEPT_SUBMIT_DONE);
      } catch (error) {
        commit(concepts.con.CONCEPT_SUBMIT_DONE);
        throw error;
      }
    },
    bindVersions: firestoreAction(
      async ({ bindFirestoreRef, commit }, data) => {
        commit(concepts.con.CONCEPT_VERSIONS_LOAD_INIT);
        try {
          const versionsRef = startsWithQuery(
            db.collection('versionedConcepts'),
            FieldPath.documentId(),
            data.conceptId
          );
          await bindFirestoreRef('versions', versionsRef);
          commit(concepts.con.CONCEPT_VERSIONS_LOAD_DONE);
        } catch (error) {
          commit(concepts.con.CONCEPT_VERSIONS_LOAD_ERROR, error);
        }
      }
    ),
    async publishConcept({ commit, state }, data) {
      commit(concepts.con.CONCEPT_PUBLISH_INIT);
      try {
        await conceptsApi.publish(state.selected.id, data.type);
        commit(concepts.con.CONCEPT_PUBLISH_DONE);
      } catch (error) {
        commit(concepts.con.CONCEPT_PUBLISH_DONE);
        throw error;
      }
    },
    async updateConcept({ commit }, data) {
      commit(concepts.con.CONCEPT_SUBMIT_INIT);
      try {
        await conceptsApi.update(data);
        commit(concepts.con.CONCEPT_SUBMIT_DONE);
      } catch (error) {
        commit(concepts.con.CONCEPT_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canPublish(),
  canUpdate(),
  paginate('concepts'),
  selectable(conceptsApi, true),
  searchable(),
  hasReferences(
    {
      collections: ['tests', 'videos'],
      field: 'steps',
      parent: 'concepts'
    },
    conceptsApi
  )
);

export default hop(concepts);
